<template>
  <p>実装待ち</p>
</template>
<script>
export default {
  name: 'PasswordResetFailed',
}
</script>
